import React from 'react'
import { BrManageContentButton } from '@bloomreach/react-sdk'
import { camelCase } from 'lodash'
import { CardWrapper } from '../Card/Card.jsx'
import Introduction, { getIntroProps } from '../Introduction/Introduction.jsx'
import Statistics, { getStatisticsParameters } from './Statistics.jsx'
import Cta from '../Cta/Cta.jsx'
import { isLocal } from '../../../global/environments/index.js'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/index.js'

const StatisticsWrapper = ({ page, component }) => {
  const { document: documentRef } = component.getModels()
  const parameters = component.getParameters()
  const documentObj = documentRef && page.getContent(documentRef)
  parameters.theme =
    ['Brand dark', 'Transparent white'].includes(parameters.backgroundColor) ||
    parameters.theme
      ? 'reversed'
      : ''
  if (!documentObj)
    return (
      <div className="u-textCenter u-paddingVert10gu">
        <h1>Select a document</h1>
      </div>
    )
  const docData = documentObj.getData()

  const processCtaLinks = (statsLinkCompound) => {
    if (statsLinkCompound.length === 0) {
      return undefined
    }
    const getHrefByType = (link, page) => {
      const href =
        link.contentType && link.contentType === 'cti:StringCompound'
          ? link?.string
          : link?.$ref && page.getContent(link?.$ref)?.links?.site?.href
      if (!href) return

      const path = isLocal() ? '/site/cti-advisorspa' : '/advisor'

      return /^http/.test(href)
        ? href
        : /^\//.test(href)
          ? `${path}${href}`
          : `${path}/${href}`
    }

    return statsLinkCompound.map((link) => {
      return {
        ...link,
        linkType: camelCase(link.linkType),
        link: link.link.map((innerLink) => {
          return {
            ...innerLink,
            linkHref: getHrefByType(innerLink, page),
          }
        }),
      }
    })
  }

  const getImageFromRef = (ref) => {
    const imageRef = ref || undefined
    return page.getContent(imageRef)?.getOriginal()?.getUrl()
  }
  const ctaProps = processCtaLinks(documentObj.getData()?.statsLinkCompound)
  const stats = docData?.ctistatsBodyCompound.map((stat) => {
    return {
      ...stat,
      link: processCtaLinks(stat.link),
    }
  })
  const introProps = getIntroProps(documentObj, parameters)
  const showIntro = introProps.title.length > 0 || introProps.content.length > 0
  return (
    <div className="u-posRelative">
      <BrManageContentButton content={documentObj} />
      <Statistics
        {...getStatisticsParameters(parameters)}
        desktopBackground={getImageFromRef(
          docData.desktopBackground?.image?.$ref
        )}
        mobileBackground={getImageFromRef(
          docData.mobileBackground?.image?.$ref
        )}
      >
        {showIntro && <Introduction {...introProps}></Introduction>}
        <CardWrapper stats={stats} parameters={parameters} />
        {ctaProps && (
          <Cta
            {...ctaProps}
            ctaAlignment={camelCase(parameters.ctaAlignment)}
            theme={camelCase(parameters.theme)}
          />
        )}
      </Statistics>
    </div>
  )
}
export default function StatisticsWrap(props) {
  return (
    <ErrorBoundary
      fallback={() =>
        !isProduction() ? <p>Erorr in StatisticsWrap component</p> : null
      }
    >
      <StatisticsWrapper {...props}></StatisticsWrapper>
    </ErrorBoundary>
  )
}
